import React from 'react'

import type { HtmlBlock as BlockProps } from '@/payload-types'

export const HtmlBlock: React.FC<BlockProps> = async ({ html }) => {
  return <div dangerouslySetInnerHTML={{ __html: html as TrustedHTML }}></div>
}
